var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSoundOffLtr = function SvgSoundOffLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.498 6.768a2.657 2.657 0 0 0-3.755.018L66.96 31.783V12L40.33 33.785h-5.425c-1.973 0-3.452.506-4.931 2.026S28 38.851 28 40.877V60.13c0 2.026.986 3.546 1.973 5.066a15.7 15.7 0 0 0 2.473 1.397L7.769 91.48l-.06.062a2.65 2.65 0 0 0 .077 3.69 2.656 2.656 0 0 0 3.755-.018L38.8 67.722l.196.025 27.963-28.302v-.123L95.516 10.52l.059-.062a2.65 2.65 0 0 0-.077-3.69M66.959 88.59 43.635 68.943l23.324-23.607zm0 0 .493.416h-.493z"
  })));
};
export default SvgSoundOffLtr;